import React from 'react';
import structureImg from "../../assets/images/structure.png"
import style from "./index.module.css"

const CompanyStructure = () => {
    return (
        <div>
            <div className={style.articleTitle}>
                组织机构图
            </div>
            <div className={style.pictureContainer}>
                <img style={{width:'100%',height:"100%"}} src={structureImg} alt=""/>
            </div>
        </div>
    );
};

export default CompanyStructure;